import React, { useState } from 'react';
import './Sidebar.css';
import { Link, useNavigate } from 'react-router-dom';
import { 
  FaBars, 
  FaBullhorn, 
  FaCalendarAlt, 
  FaUser, 
  FaEnvelope, 
  FaCog, 
  FaHome, 
  FaSignOutAlt,
  FaAddressBook 
} from 'react-icons/fa';
import { authService } from '../../../api';

const Sidebar = () => {
  const [collapsed, setCollapsed] = useState(false);
  const navigate = useNavigate();

  const toggleSidebar = () => {
    setCollapsed(!collapsed);
  };

  const handleLogout = () => {
    authService.logout();
    navigate('/connexion');
  };

  return (
    <div className={`admin-sidebar ${collapsed ? 'collapsed' : ''}`}>
      <div className="sidebar-header">
        <h3>{!collapsed && 'Administration'}</h3>
        <button className="toggle-btn" onClick={toggleSidebar}>
          <FaBars />
        </button>
      </div>
      <ul className="sidebar-menu">
        <li>
          <Link to="/admin">
            <FaHome />
            {!collapsed && <span>Accueil</span>}
          </Link>
        </li>
        <li>
          <Link to="/admin/annonces">
            <FaBullhorn />
            {!collapsed && <span>Annonces</span>}
          </Link>
        </li>
        <li>
          <Link to="/admin/evenements">
            <FaCalendarAlt />
            {!collapsed && <span>Événements</span>}
          </Link>
        </li>
        <li>
          <Link to="/admin/utilisateurs">
            <FaUser />
            {!collapsed && <span>Utilisateurs</span>}
          </Link>
        </li>
        {/* <li>
          <Link to="/admin/messages">
            <FaEnvelope />
            {!collapsed && <span>Messages</span>}
          </Link>
        </li> */}
        <li>
          <Link to="/admin/contacts">
            <FaAddressBook />
            {!collapsed && <span>Contacts</span>}
          </Link>
        </li>
        {/* <li>
          <Link to="/admin/sous-services">
            <FaCog />
            {!collapsed && <span>Sous-services</span>}
          </Link>
        </li> */}
        <li>
          <button onClick={handleLogout} className="logout-btn">
            <FaSignOutAlt />
            {!collapsed && <span>Déconnexion</span>}
          </button>
        </li>
      </ul>
    </div>
  );
};

export default Sidebar;